import './styles.scss';

import * as React from 'react';

import { withDefaults } from '../../../utils/object';
import Step from './Step';

const DEFAULTS = {
  header: null,
  cancelHandler: () => {},
  children: []
};

class Wizard extends React.Component<any, any> {
  state = {
    stepIndex: 0,
    names: React.Children.toArray(withDefaults(DEFAULTS, this.props).children).map(
      (step: any, i) => step.props.name || `Step ${i + 1}`
    )
  };

  render() {
    const { header } = withDefaults(DEFAULTS, this.props);

    return (
      //@ts-expect-error TODO
      <div className="wizard" ref={ref => (this.wizardRef = ref)}>
        {header && this.renderHeader()}
        {this.renderStep()}
      </div>
    );
  }

  steps = () => React.Children.toArray(withDefaults(DEFAULTS, this.props).children);

  currentStep = () => this.steps()[this.state.stepIndex];

  renderHeader = () => {
    const { header } = withDefaults(DEFAULTS, this.props);
    const { stepIndex: currentStepIndex, names: steps } = this.state;

    return header({ steps, currentStepIndex, className: 'wizard__header' });
  };

  renderStep = () => {
    const { cancelHandler } = withDefaults(DEFAULTS, this.props);

    //@ts-expect-error TODO
    return React.cloneElement(this.currentStep(), {
      prev: this.prev,
      next: this.next,
      cancelHandler,
      stepNames: this.state.names,
      stepIndex: this.state.stepIndex
    });
  };

  //@ts-expect-error TODO
  shouldSkipStep = stepIndex => {
    const nextStep = this.steps()[stepIndex];
    //@ts-expect-error TODO
    const skipFunc = nextStep.props.skipIf;

    return skipFunc && skipFunc();
  };

  prev = async (params = {}) => {
    try {
      //@ts-expect-error TODO
      const result = await this.currentStep().props.onStepBack(params);

      //@ts-expect-error TODO
      if (!this.wizardRef) {
        return;
      }

      if (this.state.stepIndex > 0) {
        const step = this.shouldSkipStep(this.state.stepIndex - 1) ? 2 : 1;

        //@ts-expect-error TODO
        this.setState(({ stepIndex }) => ({ stepIndex: stepIndex - step }));
      }

      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  next = async (params = {}) => {
    try {
      //@ts-expect-error TODO
      const result = await this.currentStep().props.onStepForward(params);

      //@ts-expect-error TODO
      if (!this.wizardRef) {
        return;
      }

      if (this.steps().length > this.state.stepIndex + 1) {
        const step = this.shouldSkipStep(this.state.stepIndex + 1) ? 2 : 1;

        this.setState(({ stepIndex }: any) => ({ stepIndex: stepIndex + step }));
      }

      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

//@ts-expect-error TODO
Wizard.Step = Step;

export default Wizard;
